import { useLocation } from "react-router-dom";

export const useMessageChannel = () => {
  // extracting channel from url
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return +params.get("channel")!;
}